import styles from "./styles/new_beneficiary.module.css";
import delete_button from "./styles/img/delete_benef.svg";
import InfoTitle from "../Info/InfoTitle";
import { Switch } from "@mui/material";
import { UserData } from "../../../Context/DataContext";
import { useAuth } from "../../../Context/AuthContext";
export const NewEmailField = ({
  content,
  id,
  edit = false,
  error,
  beneficiary,
  setBenefEmailFields,
  benefEmailFields,
  setBeneficiary,
  editBeneficiary,
  dublicatedcontent,
  /*
    Whether the person being written to is a guardian. The address itself is the
    beneficiary's `email_2`/`email_3` either way — only the wording turns, the
    same way it does on the first address above.
  */
  minor = false,
  /*
    A partner's suggested change to THIS address, asked where it sits. Both
    default to nothing, so Add Beneficiary -- where no partner has proposed
    anything yet -- renders exactly as it did.
  */
  renderProposal = () => null,
  proposalMark = () => "",
}) => {
  const userData = UserData();
  const auth = useAuth();
  const index = benefEmailFields.findIndex((item) => item.id === id);
  const removeItem = (indexToRemove) => {
    // Use filter to create a new array without the item to remove

    if (benefEmailFields.length === 1 && index + 1 === 1) {
      setBeneficiary((prev) => {
        return { ...prev, email_2: "", awareness_status_2: "false" };
      });
    } else if (benefEmailFields.length > 1 && index + 1 === 1) {
      setBeneficiary((prev) => {
        return {
          ...prev,
          email_2: prev.email_3,
          email_3: "",
          awareness_status_3: "false",
          awareness_status_2: prev.awareness_status_3,
        };
      });
    } else if (benefEmailFields.length > 1 && index + 1 === 2) {
      setBeneficiary((prev) => {
        return { ...prev, email_3: "", awareness_status_3: "false" };
      });
    }

    setBenefEmailFields((prev) => {
      return prev.filter((item) => {
        return item.id !== indexToRemove;
      });
    });

    return;
  };

  return (
    <div>
      {/*
        This heading is already a space-between row carrying the delete
        icon, so the switch goes straight into it rather than in a wrapper
        of its own -- which would have pushed the icon into the middle.
      */}
      <div className={`${styles.input_title} ${styles.extraBenefContainer}`}>
        <p className={` ${styles.required_field}`} style={{ margin: 0 }}>
          {
            dublicatedcontent[
              `${index + 2}_${minor ? "guardian" : "beneficiary"}_email_address`
            ]
          }
        </p>
        {renderProposal(
          `email_${index + 2}`,
          dublicatedcontent[
            `${index + 2}_${minor ? "guardian" : "beneficiary"}_email_address`
          ]
        )}
        <img
          src={delete_button}
          alt="delete"
          style={{
            cursor: "pointer",
          }}
          onClick={(e) => {
            removeItem(id);
          }}
        />
      </div>
      <input
        value={
          index + 1 === 1
            ? benefEmailFields[0].email
            : benefEmailFields[1].email
        }
        onChange={(e) => {
          setBenefEmailFields((prev) => {
            const x = prev.findIndex((item) => item?.id === id);

            if (x !== -1) {
              prev[x].email = e.target.value; //
            }

            return prev;
          });
          if (edit === true) {
            setBeneficiary((prev) => {
              return {
                ...prev,
                [`email_${index + 2}`]: e.target.value.toLowerCase(),
              };
            });
          }
          edit === false &&
            editBeneficiary(`email_${index + 2}`, e.target.value.toLowerCase());
        }}
        className={`${styles.beneficiary_input} ${
          (index + 1 === 1 ? error.email_2 : error.email_3)
            ? styles.input_error
            : ""
        } ${proposalMark(`email_${index + 2}`)}`}
        placeholder="Email"
      ></input>
      <div className={styles.error_message}>
        {index + 1 === 1 && error.email_2 ? error.email_2 : null}
        {index + 1 === 2 && error.email_3 ? error.email_3 : null}
      </div>
      <div className={styles.choice}>
        <InfoTitle
          message={
            edit === false
              ? minor
                ? content.newBeneficiaryText51
                : content.newBeneficiaryText21
              : minor
              ? content.EditBeneficiaryText48
              : content.EditBeneficiaryText17
          }
          title={
            edit === false
              ? minor
                ? content.newBeneficiaryText50
                : content.newBeneficiaryText22
              : minor
              ? content.EditBeneficiaryText47
              : content.EditBeneficiaryText18
          }
          type={"small"}
        />
        <div
          disabled={userData.isFreezed || auth.awareness_email >= 12}
          className={styles.choice_container}
        >
          <span className={styles.switch_option}>
            {dublicatedcontent?.dublicatedText102}
          </span>
          <div className={styles.switch_toggle}>
            <Switch
              checked={
                index + 1 === 1
                  ? beneficiary?.awareness_status_2 === "true"
                  : beneficiary?.awareness_status_3 === "true"
              }
              onClick={() => {
                if (index + 1 === 1) {
                  setBeneficiary({
                    ...beneficiary,
                    awareness_status_2:
                      beneficiary?.awareness_status_2 === "true"
                        ? "false"
                        : "true",
                  });
                } else if (index + 1 === 2) {
                  setBeneficiary({
                    ...beneficiary,
                    awareness_status_3:
                      beneficiary?.awareness_status_3 === "true"
                        ? "false"
                        : "true",
                  });
                }
              }}
            />
          </div>
          <span
            className={styles.switch_option}
            style={{ marginRight: "10px" }}
          >
            {edit === false
              ? content.newBeneficiaryText23
              : content.EditBeneficiaryText19}
          </span>
        </div>
      </div>
      {auth.awareness_email >= 12 && (
        <div className={styles.error_message}>
          {edit === false
            ? content.newBeneficiaryText24
            : content.EditBeneficiaryText20}
        </div>
      )}
    </div>
  );
};
